import { Component, inject, OnInit } from '@angular/core';
import { WorkAuthenticationV2Service } from '@work-frontend-monorepo/work-rest-api';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { Store } from '@ngxs/store';
import { StateReset } from 'ngxs-reset-plugin';
import { ProfileState } from '@work-frontend-monorepo/work-ui/state-management';

@Component({
  selector: 'sfg-app-auth-logout-page',
  templateUrl: './auth-logout-page.component.html',
  standalone: true,
  imports: [],
})
export class AuthLogoutPageComponent implements OnInit {
  private readonly workAuthenticationV2Service = inject(WorkAuthenticationV2Service);
  private readonly store = inject(Store);
  private readonly router = inject(Router);

  async ngOnInit() {
    try {
      await lastValueFrom(this.workAuthenticationV2Service.authenticationV2ControllerLogout({ body: {} }));
    } catch (logoutException) {
      // Nothing to do here.
    }
    this.store.dispatch(new StateReset(ProfileState));
    await this.router.navigateByUrl('/');
  }
}
